export const HOSTS = {
    login: process.env.REACT_APP_HOST_LOGIN,
    adminLogin: process.env.REACT_APP_HOST_ADMIN_LOGIN,
    teacherLogin: process.env.REACT_APP_HOST_TEACHER_LOGIN,
    report: process.env.REACT_APP_HOST_REPORT,
    adminReport: process.env.REACT_APP_HOST_ADMIN_REPORT,
    teacherReport: process.env.REACT_APP_HOST_TEACHER_REPORT,
    adminSchedule: process.env.REACT_APP_HOST_ADMIN_SCHEDULE,
    teacherSchedule: process.env.REACT_APP_HOST_TEACHER_SCHEDULE
};
